
// export const actions = {
  mPGSCardUsed
    export const options = ({commit}, data) => {
        commit('options', data);
    }

    export const mPGSCardUsed = ({commit}, data) => {
      commit('mPGSCardUsed', data);
  }
    export const showDefaultView = ({commit}, data) => {
      commit('showDefaultView', data);
  }
    
    export const api_key = ({commit}, data) => {
      commit('api_key', data);
  }
    
    export const payload =  ({commit},  data) =>{
      commit('payload', data);
    }

    export const service_call_payload =  ({commit},  data) =>{
      commit('service_call_payload', data);
    }

    

    export const cardDetails =  ({commit},  data) =>{
      commit('cardDetails', data);
    }
  
    export const card_cc =  ({commit},  data) =>{
      commit('card_cc', data);
    }

    export const card_exp =  ({commit},  data) =>{
      commit('card_exp', data);
    }
    export const card_cvv =  ({commit},  data) =>{
      commit('card_cvv', data);
    }    

    export const paymentMethodName =  ({commit},  data) => {
      commit('paymentMethodName', data);
    }

    export const paymentMethod =  ({commit},  data) => {
      commit('paymentMethod', data);
    }


    export const paymentMethodIndex =  ({commit},  data) => {
      commit('paymentMethodIndex', data);
    }

    export const isFailed =  ({commit},  data) => {
        commit('isFailed', data);
    }
    
    export const transRef =  ({commit},  data) => {
        commit('transRef', data);
    }

    export const parentTransRef =  ({commit},  data) => {
      commit('parentTransRef', data);
    }

    export const provider = ({commit}, data) => {
      commit('provider', data)
    }

    export const channels = ({commit}, val) => {
      commit('channels', val)
    }

    export const popupReferrer = ({commit}, val) => {
      commit('popupReferrer', val)
    }

    export const client_info = ({commit}, val) => {
      commit ('client_info', val)
    }

    export const app_info = ({commit}, val) => {
      commit ('app_info', val)
    }

    export const optionsTransRef = ({commit}, val ) => {
      commit ('optionsTransRef', val)
    }

    export const paymentMethodProvider = ({commit}, val ) => {
      commit ('paymentMethodProvider', val)
    }

    export const customer_processing_fee = ({commit}, val ) => {
      commit ('customer_processing_fee', val)
    }

    

// };
